import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ResetNewPasswordFormInputContainer from 'src/app/containers/Reset/ResetNewPasswordFormInputContainer';
import { resetNewPasswordSend } from 'src/app/redux/actions/reset/resetNewPasswordSend';
import {
  resetNewPasswordSetValidationMessage,
  resetNewPasswordSetVisualization
} from 'src/app/redux/actions/reset/resetNewPassword';
import 'src/app/containers/Reset/ResetNewPasswordFormContainer.scss';


class ResetNewPasswordFormContainer extends React.Component {
  inputRef = React.createRef();

  onSubmit = (event) => {
    event.preventDefault();

    const { dispatch, value } = this.props;
    const { current } = this.inputRef;
    const form = event.target;

    if (!form.checkValidity()) {
      dispatch(resetNewPasswordSetValidationMessage(current.validationMessage));
      dispatch(resetNewPasswordSetVisualization(true));
      return;
    }

    dispatch(resetNewPasswordSend(value));
  };

  render() {
    const { onSubmit, inputRef } = this;
    return (
      <form onSubmit={ onSubmit } styleName="new-password" noValidate>

        <div styleName="new-password__title title">
          <h4 styleName="title__primary">Ustal nowe hasło</h4>
          <p styleName="title__secondary">
            Od teraz będziesz się nim posługiwać na Pracuj.pl
          </p>
        </div>

        <ResetNewPasswordFormInputContainer { ...{ inputRef } }/>

        <button styleName="new-password__send"
                type="submit"
                data-test="button-set-password"
        >
          Zmień
        </button>
      </form>
    );
  }
}

ResetNewPasswordFormContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  value: state.resetNewPasswordReducer.value
});

export default connect(mapStateToProps)(ResetNewPasswordFormContainer);
